import type { DbUser } from '@leangap/types'

export function migrateApplicationStatus(user: DbUser): DbUser {
	if (Array.isArray(user.application_status) && user.application_status.length === 4) {
		return {
			...user,
			application_status: {
				general: !!user.application_status[0],
				background: !!user.application_status[1],
				program: !!user.application_status[2],
				aid: !!user.application_status[3],
			},
		}
	}
	return user
}
